module.exports = __webpack_public_path__ + "static/treant-d9cc20075f3f33d74a144c9ac28b49c9.jpg";